import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CatalogRequest } from '../models/catalog-request.model';
import { CatalogResponse } from '../models/catalog-response.model';
import { ServiciosRapidosResponse } from '../models/priority-assistance.model';

@Injectable({
  providedIn: 'root',
})
export class CatalogService {
  private readonly baseUrl = environment.apiBaseUrl;
  private serviciosRapidosCache = new Map<string, Observable<ServiciosRapidosResponse>>();
  
  constructor(private http: HttpClient) {}

  getCatalog(request: CatalogRequest): Observable<CatalogResponse> {
    const token = localStorage.getItem('accessToken') || '';
    const cognitoId = localStorage.getItem('cognito') || '';
    const url = `${this.baseUrl}/user/${cognitoId}/catalog`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `${token}`,
    });

    return this.http.post<CatalogResponse>(url, request, { headers });
  }

  getServiciosRapidos(account: string): Observable<ServiciosRapidosResponse> {
    if (!this.serviciosRapidosCache.has(account)) {
      const request$ = this.http.get<ServiciosRapidosResponse>(
        `${this.baseUrl}/load/${account}/ServiciosRapidos`
      ).pipe(
        shareReplay({ bufferSize: 1, refCount: false })
      );
      this.serviciosRapidosCache.set(account, request$);
    }
    return this.serviciosRapidosCache.get(account)!;
  }

  clearCache(): void {
    this.serviciosRapidosCache.clear();
  }
}
